import Model, { attr } from '@ember-data/model'
import { Type } from '@warp-drive/core-types/symbols'
import type StringTransform from 'teacher-ui-client/transforms/string'

export default class ImportSchedule extends Model {
  @attr<StringTransform>('string') declare status: string;

  [Type] = 'import-schedule' as const
}
